import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterLink } from '@angular/router';

import { MoveBusinessComponent } from './components/move-business.component';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { AppSharedModule } from './../shared/appShared.module';
import { AdminAndPortalListResolver } from './services/move-business.resolver';
import { MoveBusinessServices } from './services/move-business.service';
import {
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { EditorModule } from 'primeng/editor';

@NgModule({
  exports: [],
  declarations: [MoveBusinessComponent],
  imports: [
    BrowserModule,
    EditorModule,
    FormsModule,
    RouterLink,
    AppSharedModule,
    TranslatePipe,
    TranslateDirective
  ],
  providers: [
    MoveBusinessServices,
    AdminAndPortalListResolver,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class MoveBusinessModule {}
